export const scrollIntoViewIfVisible = (target: Element) => {
  if (target.getBoundingClientRect().bottom > window.innerHeight) {
    target.scrollIntoView({ behavior: 'instant', block: 'end' });
  }

  if (target.getBoundingClientRect().top < 0) {
    target.scrollIntoView({ behavior: 'instant', block: 'start' });
  }
};
